module.exports = __webpack_public_path__ + "img/banner.f0738017.png";